module.exports = __webpack_public_path__ + "static/media/luberly_2.522f5f26.png";